var map = {
	"./channel/index.tsx": 8746,
	"./specialDisease/goldIcons/index.tsx": 5402,
	"./specialDisease/hotContent/index.tsx": 4016,
	"./specialDisease/naviH/index.tsx": 5314,
	"./specialDisease/slidebar/index.tsx": 8054,
	"./specialDisease/swiper/index.tsx": 9072,
	"./specialDisease/topcard/index.tsx": 1343,
	"./specialDisease/topic/index.tsx": 9755,
	"./specialDisease/videoSwiper/index.tsx": 2529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4921;